function t(t,r){t.replace(/;\s*$/,"").split(";").forEach((t=>{if(!t)return;const[e,i]=t.split(":");r[e.trim().toLowerCase()]=i.trim()}))}export{t as parseStyleString};
//# sourceMappingURL=parseStyleString.min.mjs.map
